import VXEStore from './store';
export var hooks = new VXEStore();
